class CategoriesToggle extends HTMLElement {
  constructor() {
    super();
    this.isOpen = false;
    this.controller = new AbortController();
  }

  connectedCallback() {
    this.button = this.querySelector('[data-categories-trigger]');
    this.list = this.querySelector('[data-categories-list]');
    this.iconPlus = this.querySelector('[data-icon-plus]');
    this.iconMinus = this.querySelector('[data-icon-minus]');

    if (this.button && this.list) {
      this.list.style.maxHeight = '0';
      this.button.addEventListener('click', () => this.toggle(), {
        signal: this.controller.signal,
      });
    }
  }

  disconnectedCallback() {
    this.controller.abort();
  }

  toggle() {
    this.isOpen = !this.isOpen;

    if (this.isOpen) {
      this.list.style.maxHeight = this.list.scrollHeight + 'px';
      if (this.iconPlus) this.iconPlus.classList.replace('block', 'hidden');
      if (this.iconMinus) this.iconMinus.classList.replace('hidden', 'block');
    } else {
      this.list.style.maxHeight = '0';
      if (this.iconPlus) this.iconPlus.classList.replace('hidden', 'block');
      if (this.iconMinus) this.iconMinus.classList.replace('block', 'hidden');
    }

    this.button.setAttribute('aria-expanded', this.isOpen);
  }
}

if (!customElements.get('categories-toggle')) {
  customElements.define('categories-toggle', CategoriesToggle);
}
